import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class GreenDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [300, 500],
				size: [0.55, 0.32],
				color: { r: 0x39, g: 0x86, b: 0x40 },
				speed: [1.5, 3.0],
				gravity: 6.0,
			},
			direction,
		);
	}
}
